import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import {FilterPriceDropDataSearchValueObject} from '../../search/ValueObjects/FilterPriceDropDataSearchValueObject.js'

/**
 * @implements Service
 */
class GetSearchResultsAdsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.repository
   * @param {Function} deps.searchRequestValueObjectFactory
   */
  constructor({config, repository, searchRequestValueObjectFactory}) {
    super()
    this._config = config
    this._repository = repository
    this._searchRequestValueObjectFactory = searchRequestValueObjectFactory

    this._unselectedOfferType = this._config.get('search').UNSELECTED_OFFER_TYPE
    this._defaultSortOrder = this._config.get('ORDER').DESC
    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE

    this._appName = this._config.get('APP_NAME')
    this._appNameMotos = this._config.get('APP_NAME_MOTOS')
    this._isMotos = this._appName === this._appNameMotos
  }

  /**
   * @param {Object} data
   * @param {Number} data.page
   * @param {String} data.sortBy
   * @param {Number} data.sortOrder
   * @param {Number} data.categoryId
   * @param {Number} data.category2Id
   * @param {Number} data.offerTypeId
   * @param {Number} data.makeId
   * @param {Object} data.model
   * @param {Array} data.fuelTypeIds
   * @param {Array} data.bodyTypeIds
   * @param {Array} data.provinceIds
   * @param {Object} data.price
   * @param {Object} data.litres
   * @param {Object} data.year
   * @param {Object} data.kms
   * @param {Number} data.sellerTypeId
   * @param {String} data.version
   */
  @inlineError
  async execute({
    batteryCapacity,
    bodyTypeIds,
    category2Id,
    category3Id,
    categoryId,
    chargingTimeFastMode,
    chargingTimeStandardMode,
    city,
    colorIds,
    commitmentMonths,
    contractId,
    doors,
    drivenWheelsIds,
    electricAutonomy,
    entry,
    environmentalLabels,
    equipments,
    excludedAdIds,
    excludedVehicles,
    fee,
    filteredOfferTypeId,
    financedPrice,
    fuelTypeIds,
    hasInstalment,
    hasOnlineFinancing,
    hasPhoto,
    hasPriceDrop,
    hasReservation,
    hasStock,
    hasWarranty,
    hp,
    isCertified,
    instalment,
    kms,
    listingSectionId,
    litres,
    location,
    luggageCapacity,
    make,
    makeId,
    maxTerms,
    model = {},
    offerTypeId,
    onlyPeninsula,
    page = 1,
    price,
    priceDrop,
    priceRank,
    provinceIds,
    rating,
    region,
    searchText,
    seats,
    sellerTypeId,
    size,
    sortBy = this._defaultSortBy,
    sortOrder = this._defaultSortOrder,
    subscriptionVehicleState,
    targetBuyer,
    transmissionTypeId,
    variant,
    vehicles,
    version,
    withAggregations = false,
    year
  }) {
    this._isMotos && delete model.id

    const searchRequestObjectValueObject = this._searchRequestValueObjectFactory({
      batteryCapacity,
      bodyTypeIds,
      category2Id,
      category3Id,
      categoryId,
      chargingTimeFastMode,
      chargingTimeStandardMode,
      city,
      colorIds,
      commitmentMonths,
      contractId,
      doors,
      drivenWheelsIds,
      electricAutonomy,
      environmentalLabels,
      equipments,
      entry,
      excludedAdIds,
      excludedVehicles,
      fee,
      filteredOfferTypeId,
      financedPrice,
      fuelTypeIds,
      hasInstalment,
      hasOnlineFinancing,
      hasPhoto,
      hasPriceDrop,
      hasReservation,
      hasStock,
      hasWarranty,
      hp,
      isCertified,
      instalment,
      kms,
      litres,
      location,
      luggageCapacity,
      make,
      makeId,
      maxTerms,
      model,
      offerTypeId,
      onlyPeninsula,
      page,
      price,
      priceDrop: hasPriceDrop ? priceDrop ?? FilterPriceDropDataSearchValueObject.create().value : undefined,
      priceRank,
      provinceIds,
      rating,
      region,
      searchText,
      seats,
      sellerTypeId,
      size,
      sortBy,
      sortOrder,
      subscriptionVehicleState,
      targetBuyer,
      transmissionTypeId,
      vehicles,
      version,
      year
    })

    const [getSearchResultsError, getSearchResultsResponse] = await this._repository.getSearchResults({
      listingSectionId,
      searchRequestObjectValueObject,
      withAggregations,
      variant
    })
    return getSearchResultsError ? Promise.reject(getSearchResultsError) : getSearchResultsResponse
  }
}

export default GetSearchResultsAdsService
